import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import ReactHtmlParser from 'react-html-parser'

const Hiring = (props) => (
  <div className='grid__block grid__block--hiring'>
    <Linker href={props.cta_link} className='grid__block-inner'>
      <span className='grid__block-label'>{props.label}</span>
      <h2 className='grid__block-title'>
        <span>{ReactHtmlParser(props.title)}</span>
        {props.subtitle}
      </h2>
      <div className='grid__block-bottom'>
        <p>{props.description}</p>
        <span className='grid__block-more'>{props.cta_text} —</span>
      </div>
    </Linker>
  </div>
)

const Linker = (props) => {
  if (props.href.startsWith('http')) { // External
    return (
      <a target='_blank' href={props.href} className={props.className}>
        {props.children}
      </a>
    )
  } else {
    return ( // Internal
      <Link to={props.href} className={props.className}>
        {props.children}
      </Link>
    )
  }
}

Hiring.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  cta_text: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
}

export default Hiring



// WEBPACK FOOTER //
// ./src/components/Grid/Hiring/index.js